import { useState } from "react";
import { connect } from "react-redux";

import AccountIcon from "@mui/icons-material/EnhancedEncryption";
import AboutIcon from "@mui/icons-material/Info";
import { Box, Link, useTheme } from "@mui/material";
import Button from "@mui/material/Button";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";

import * as UserSessionActions from "../../state/redux/userSession";
import Dialog from "../ui/omniDialog";
import DialogActions from "../ui/omniDialogActions";
import DialogContent from "../ui/omniDialogContent";
import DialogTab from "../ui/omniDialogTab";
import DialogTabs from "../ui/omniDialogTabs";
import DialogTitle from "../ui/omniDialogTitle";

const UserSettingsDialog = props => {
  const {
    dialogTitle = "Settings",
    okMessage = "ok",
    maxWidth = "sm",
    fullWidth = true,
    organizationODM,
    awsGroup,
    showSettings,
    awsUser,
  } = props;

  const [tabIndex, setTabIndex] = useState(0);

  const onCloseHandler = () => {
    props.setShowSettingsRequest(false);
  };

  const theme = useTheme();

  return (
    <Dialog
      open={showSettings}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          onCloseHandler();
        }
      }}
      disableEscapeKeyDown
      maxWidth={maxWidth}
      fullWidth={fullWidth}
    >
      <DialogTitle onClose={onCloseHandler}>{dialogTitle}</DialogTitle>
      <DialogTabs tabIndex={tabIndex} setTabIndex={setTabIndex}>
        <Tab key={`tab0`} icon={<AccountIcon />} label="Account" />
        <Tab key={`tab1`} icon={<AboutIcon />} label="About" />
      </DialogTabs>
      <DialogContent>
        <DialogTab selectedIndex={tabIndex} index={0}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              webkitUserSelect: "none",
              userSelect: "none",
              minHeight: 200,
            }}
          >
            <Typography variant="overline" noWrap>
              {`User Name`}
            </Typography>
            <Typography
              sx={{ marginTop: `-${theme.spacing(1)}`, marginLeft: theme.spacing(1) }}
              variant="h5"
              noWrap
            >
              {awsUser ? awsUser.username : "..."}
            </Typography>
            <Typography variant="overline" noWrap>
              {`User Group`}
            </Typography>
            <Typography
              sx={{ marginTop: `-${theme.spacing(1)}`, marginLeft: theme.spacing(1) }}
              variant="h5"
              noWrap
            >
              {awsGroup}
            </Typography>
            <Typography variant="overline" noWrap>
              {`Organization`}
            </Typography>
            <Typography
              sx={{ marginTop: `-${theme.spacing(1)}`, marginLeft: theme.spacing(1) }}
              variant="h5"
              noWrap
            >
              {/* Need actual data for this */}
              {organizationODM != null ? organizationODM.omniData.name : ""}
            </Typography>
          </Box>
        </DialogTab>

        <DialogTab selectedIndex={tabIndex} index={1}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              webkitUserSelect: "none",
              userSelect: "none",
              height: "100%",
            }}
          >
            <Typography variant="overline" noWrap>
              Health Coach
            </Typography>
            <Typography sx={{ marginTop: `-${theme.spacing(1.5)}` }} variant="h5" noWrap>
              {`version ${process.env.REACT_APP_VERSION}`}
            </Typography>
            <Typography variant="overline" noWrap>
              Product Silo
            </Typography>
            <Typography sx={{ marginTop: `-${theme.spacing(1.5)}` }} variant="h5" noWrap>
              {process.env.NODE_ENV}
            </Typography>
            <Typography variant="overline" noWrap>
              Legalities
            </Typography>
            <Typography sx={{ marginTop: `-${theme.spacing(1.5)}` }} variant="h5" noWrap>
              <Link
                href={`${
                  window.location.origin.includes("localhost")
                    ? `https://dev.omnisciahealth.coach`
                    : window.location.origin
                }/assets/legal/TOS.html`}
                to="route"
                target="_blank"
                sx={{ color: theme.palette.primary.main }}
              >
                Service
              </Link>
            </Typography>
            <Typography sx={{ marginTop: theme.spacing(0.5) }} variant="h5" noWrap>
              <Link
                href={`${
                  window.location.origin.includes("localhost")
                    ? `https://dev.omnisciahealth.coach`
                    : window.location.origin
                }/assets/legal/privacypolicy.html`}
                to="route"
                target="_blank"
                sx={{ color: theme.palette.primary.main }}
              >
                Privacy Policy
              </Link>
            </Typography>
            <Typography sx={{ marginTop: theme.spacing(0.5) }} variant="h5" noWrap>
              <Link
                href={`${
                  window.location.origin.includes("localhost")
                    ? `https://dev.omnisciahealth.coach`
                    : window.location.origin
                }/assets/legal/PromotionTermsAndConditions.html`}
                to="route"
                target="_blank"
                sx={{ color: theme.palette.primary.main }}
              >
                Promotion Terms And Conditions
              </Link>
            </Typography>
          </Box>
        </DialogTab>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCloseHandler} color="secondary" variant="contained">
          {okMessage}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = state => ({
  themeId: state.userSession.themeId,
  awsGroupMemberships: state.userSession.awsGroupMemberships,
  awsGroup: state.userSession.awsGroup,
  awsUser: state.userSession.awsUser,
  showSettings: state.userSession.showSettings,
  organizationODM: state.userSession.organizationODM,
});

const mapDispatchToProps = {
  setThemeRequest: UserSessionActions.setThemeRequest,
  setAwsGroupRequest: UserSessionActions.setAwsGroupRequest,
  setShowSettingsRequest: UserSessionActions.setShowSettingsRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserSettingsDialog);
